import DynamicFavicon from './DynamicFavicon'
export default DynamicFavicon
